import { useEffect, useState } from "react";
import api from "./api";
import { getHomepageCache, fetchHomepage } from "./homepage";

export const LE_TXT = {
  le_eb_live: "En ce moment · {n} édition{s} limitée{s}",
  le_eb_none: "Pas d'édition en cours",
  le_h1_pre: "Éditions",
  le_h1_accent: "limitées",
  le_lede: "Des recettes d'un moment, cuites en petite série. Quand la date est passée, elles quittent le site.",
  le_stamp: "ÉDITION LIMITÉE ✦ FAIT MAIN ✦ PETITE SÉRIE ✦ ",
  le_pill_until: "· jusqu'au {date}",
  le_btn_see_one: "Voir l'édition",
  le_btn_see_many: "Voir les éditions",
  le_pill_none: "La prochaine arrive bientôt",
  le_btn_notify: "Me prévenir",
  le_tape: "Édition limitée\nPetite série\nFait main à Palaiseau\nQuand c'est fini, c'est fini",
  le_tape_until: "Jusqu'au {date}",
  le_feat_until: "Disponible jusqu'au {date}",
  le_unit: "l'unité",
  le_btn_want: "Je le veux",
  le_btn_custom: "Personnaliser",
  le_btn_view: "Voir le produit",
  le_btn_back: "Me prévenir du retour",
  le_sold_tag: "Épuisé",
  le_gauge_left: "Plus que {left} sur {total}",
  le_gauge_reserved: "{sold} déjà réservées",
  le_gauge_low: "Dernières pièces",
  le_gauge_out: "Série épuisée",
  le_cd_days: "Plus que {d} j {h} h",
  le_cd_hours: "Plus que {h} h {m} min",
  le_delivery: "Retrait à Palaiseau, point relais dès 4,10 € ou livraison à domicile dès 7,95 €.",
  le_empty_k: "Pas d'édition en cours",
  le_empty_pre: "La prochaine",
  le_empty_accent: "arrive.",
  le_empty_text: "Aucune édition limitée n'est disponible pour le moment. Laisse ton e-mail un peu plus bas : tu es prévenu(e) dès qu'une nouvelle sort.",
  le_more_k: "En même temps",
  le_more_pre: "Aussi en",
  le_more_accent: "édition limitée",
  le_more_count: "{n} autre{s} édition{s}",
  le_card_line: "Jusqu'au {date}",
  le_card_left: " · plus que {left}",
  le_how1_title: "Jusqu'au {date}",
  le_how1_text: "Passé cette date, l'édition quitte le site.",
  le_how2_title: "Quantité limitée",
  le_how2_text: "Chaque édition est préparée en petite série.",
  le_how3_title: "Retrait ou livraison",
  le_how3_pick: "Retrait uniquement",
  le_next_eb: "La suite",
  le_next_pre: "Ne rate pas",
  le_next_accent: "la prochaine.",
  le_next_text: "Laisse ton e-mail : tu es prévenu(e) dès qu'une nouvelle édition limitée sort.",
  le_reveal: "Dévoilement bientôt",
  le_next_ph: "Ton e-mail",
  le_next_btn: "Me prévenir",
  le_next_consent: "J'accepte de recevoir un e-mail à la sortie d'une nouvelle édition. Je peux me désinscrire à tout moment.",
  le_next_sent: "C'est noté, on te prévient !",
  le_next_err_mail: "Entre une adresse e-mail valide",
  le_next_err_consent: "Coche la case pour recevoir l'alerte",
  le_past_pre: "Déjà",
  le_past_accent: "parties",
  le_past_text: "Elles ont eu leur moment. Active l'alerte ci-dessus pour ne pas rater la suite.",
  le_past_badge: "Terminée",
  le_past_line: "Terminée le {date}",
  le_top_label: "Édition limitée",
  le_top_many: "{n} éditions en cours",
  le_top_go: "J'en profite",
  le_hstamp: "ÉDITION LIMITÉE ✦ PLUS QUE ✦ ÉDITION LIMITÉE ✦ ",
  le_home_k: "Édition limitée · jusqu'au {date}",
  le_home_cta: "Découvrir",
  le_strip: "Édition limitée en ce moment :",
  le_badge: "Édition limitée",
  le_pp_until: "Jusqu'au {date}",
  le_pp_ended_line: "Terminée le {date}",
  le_pp_ended: "Cette édition est terminée.",
  le_pp_soldout: "Série épuisée.",
  le_pp_notify: "Me prévenir de la prochaine",
  le_pp_before: "À commander avant le {date}",
  le_pp_all: "Toutes les éditions limitées",
  le_cart_label: "Édition limitée",
  pick_label: "Retrait uniquement",
  pick_page: "Ce produit ne s'expédie pas : à récupérer sur place.",
  pick_default: "Retrait à Palaiseau uniquement",
  pick_cart: "Un produit de ton panier est en retrait uniquement : le point relais et la livraison ne sont pas possibles pour cette commande.",
};

export const LE_TOGGLES = {
  limited_visible: "Page Éditions limitées en ligne",
  le_menu_on: "Lien « Éditions limitées » dans le menu",
  le_top_on: "Barre orange tout en haut du site",
  le_hstamp_on: "Tampon qui tourne sur la photo d'accueil",
  le_home_on: "Grande carte sur l'accueil (après « Nos gourmandises »)",
  le_strip_on: "Bandeau orange sur la page Cookies",
  le_next_on: "Bloc « Ne rate pas la prochaine »",
  le_reveal_on: "Texte « Dévoilement » dans ce bloc",
  le_past_on: "Section « Déjà parties »",
};

export const fill = (t, v = {}) => String(t).replace(/\{(\w+)\}/g, (m, k) => (v[k] ?? m));
export const lt = (hp, k, v) => fill(String(hp?.[k] ?? "").trim() || LE_TXT[k], v);
export const leOn = (hp, k) => hp?.[k] !== false;
export const plural = (n) => (n > 1 ? "s" : "");
export const frDate = (ts, year) => (ts ? new Date(ts).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: year ? "numeric" : undefined, timeZone: "Europe/Paris" }) : "");

export const leStatus = (p, now = Date.now()) => {
  if (!p?.limited_edition) return null;
  if (p.le_start_ts && now < p.le_start_ts) return "hidden";
  if (p.le_end_ts && now > p.le_end_ts) return "ended";
  if ((p.stock ?? 0) <= 0) return "soldout";
  return "live";
};
export const leLow = (p) => Math.ceil((p.le_stock_total || 0) * (Number(p.le_low_pct) || 20) / 100);
export const gaugeOn = (p) => !!p.le_gauge && (p.le_stock_total || 0) > 0;
export const isPickOnly = (p) => !!p?.pickup_only || (Array.isArray(p?.reception_modes) && p.reception_modes.length > 0 && p.reception_modes.every((m) => m === "pickup"));
export const pickText = (hp, p) => (p?.pickup_text || "").trim() || lt(hp, "pick_default");
export const inBox = (p) => (p.limited_edition ? p.box_allowed === true : p.box_allowed !== false);
export const boxSup = (p) => (p?.limited_edition && p.box_allowed === true ? Math.max(0, Number(p.box_supplement) || 0) : 0);
export const isCustom = (p) => p.customizable !== false;
export const DAYS_FR = ["lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi", "dimanche"];
export const daysLabel = (d) => {
  const l = [...new Set((d || []).filter((x) => x >= 0 && x <= 6))].sort().map((x) => DAYS_FR[x]);
  if (!l.length || l.length === 7) return "";
  return l.length === 1 ? l[0] : `${l.slice(0, -1).join(", ")} ou ${l[l.length - 1]}`;
};

export function cdParts(end, now) {
  const s = Math.max(0, Math.floor((end - now) / 1000));
  return { d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
}
export const p2 = (n) => String(n).padStart(2, "0");
export const cdShort = (hp, end, now) => {
  const c = cdParts(end, now);
  return c.d > 0 ? lt(hp, "le_cd_days", { d: c.d, h: p2(c.h) }) : lt(hp, "le_cd_hours", { h: p2(c.h), m: p2(c.m) });
};

const tickers = new Set();
let tickIv = null;
const slow = () => typeof window !== "undefined" && window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
export function useNow(on = true) {
  const [n, setN] = useState(Date.now);
  useEffect(() => {
    if (!on) return undefined;
    tickers.add(setN);
    if (!tickIv) tickIv = setInterval(() => { if (!document.hidden) { const t = Date.now(); tickers.forEach((f) => f(t)); } }, slow() ? 30000 : 1000);
    return () => { tickers.delete(setN); if (!tickers.size) { clearInterval(tickIv); tickIv = null; } };
  }, [on]);
  return n;
}

let leCache = null;
let leInflight = null;
let leLoaded = 0;
let leIv = null;
const leSubs = new Set();
const LE_TTL = 5 * 60 * 1000;
try {
  const c = JSON.parse(sessionStorage.getItem("cs_le"));
  leCache = c && c.t && Date.now() - c.t < LE_TTL ? c.d : null;
} catch { leCache = null; }
function loadLe() {
  if (leInflight) return leInflight;
  leInflight = api.get("/limited").then((r) => {
    leCache = r.data; leLoaded = Date.now();
    try { sessionStorage.setItem("cs_le", JSON.stringify({ t: leLoaded, d: leCache })); } catch { /* quota */ }
    leSubs.forEach((f) => f(leCache));
  }).catch(() => {}).finally(() => { leInflight = null; });
  return leInflight;
}
export function useLimited() {
  const [s, setS] = useState(leCache);
  useEffect(() => {
    leSubs.add(setS);
    if (Date.now() - leLoaded > 60000) loadLe();
    if (!leIv) leIv = setInterval(() => { if (!document.hidden) loadLe(); }, 60000);
    return () => { leSubs.delete(setS); if (!leSubs.size) { clearInterval(leIv); leIv = null; } };
  }, []);
  const now = Date.now();
  const all = [...(s?.live || []), ...(s?.past || [])];
  const live = all.filter((p) => ["live", "soldout"].includes(leStatus(p, now)));
  const past = all.filter((p) => leStatus(p, now) === "ended");
  return { live, past, loaded: !!s };
}

export function useHp() {
  const [hp, setHp] = useState(getHomepageCache);
  useEffect(() => { fetchHomepage().then(setHp).catch(() => {}); }, []);
  return hp || {};
}

export const getHpCache = () => getHomepageCache() || {};
